import React, { useEffect, useState } from "react";
import {
  viewLeaveApplications,
  getTeamMembersLeaveApplications,
  getMembers_Leader,
} from "../../http";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loading from "../Loading";

const LeaveApplications = () => {
  const { user } = useSelector((state) => state.authSlice);
  const [type, setType] = useState();
  const [status, setStatus] = useState();
  const [appliedDate, setAppliedDate] = useState();
  const [applications, setApplications] = useState();
  const [teamLeaves, setTeamLeaves] = useState();
  const [teamLeavesLoading, setTeamLeavesLoading] = useState(false);
  const history = useHistory();
  const [users, setUsers] = useState();
  const isLeader = user && (user.type === "leader" || user.type === "Leader");

  useEffect(() => {
    const obj = {
      applicantID: user.id,
    };

    const fetchData = async () => {
      const res = await viewLeaveApplications(obj);
      const { data } = res;
      setApplications(data);

      // If user is a leader, fetch team leaves
      if (isLeader) {
        try {
          setTeamLeavesLoading(true);
          const teamLeaveRes = await getTeamMembersLeaveApplications(user.id);
          const ress = await getMembers_Leader();
          if (ress.success) {
            setUsers(ress.data);
          }
          console.log(teamLeaveRes);
          if (teamLeaveRes && teamLeaveRes.data && teamLeaveRes.success) {
            setTeamLeaves(teamLeaveRes.data);
          }
        } catch (error) {
          console.error("Error fetching team leaves:", error);
        } finally {
          setTeamLeavesLoading(false);
        }
      }
    };
    fetchData();
  }, [user.id, isLeader]);

  const searchLeaveApplications = async () => {
    const obj = {
      applicantID: user.id,
    };

    if (type) {
      obj["type"] = type;
    }
    if (status) {
      obj["adminResponse"] = status;
    }
    if (appliedDate) {
      obj["appliedDate"] = appliedDate;
    }

    const res = await viewLeaveApplications(obj);
    const { data } = res;
    setApplications(data);

    setAppliedDate("");
    setType("");
    setStatus("");
  };

  const handleViewLeaveDetails = (leaveId) => {
    history.push(`/teamLeaveDetails/${leaveId}`);
  };

  return (
    <>
      {applications ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Leave Applications</h4>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center align-items-center w-100 gap-2">
              <div className="form-group col-md-2 col-12 mb-2">
                <label>Leave Type</label>
                <select
                  name="type"
                  onChange={(e) => setType(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Half day</option>
                  <option>Full Day</option>
                </select>
              </div>

              <div className="form-group col-md-2 col-12 mb-2">
                <label>Status</label>
                <select
                  name="type"
                  onChange={(e) => setStatus(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Pending</option>
                  <option>Approved</option>
                  <option>Rejected</option>
                </select>
              </div>

              <div className="form-group col-md-4 col-12 mb-2">
                <label>Applied Date</label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <div className="input-group-text">
                      <i className="fa fa-calendar"></i>
                    </div>
                  </div>
                  <input
                    onChange={(e) => setAppliedDate(e.target.value)}
                    type="date"
                    id="startDate"
                    name="startDate"
                    className="form-control"
                  />
                </div>
              </div>

              <button
                onClick={searchLeaveApplications}
                className="btn btn-lg btn-primary col-md col-12 mt-2">
                Search
              </button>
            </div>
          </section>
          <div className="table-responsive mt-3">
            <table className="table table-striped table-md center-text">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Title</th>
                  <th>Applied Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody className="sidebar-wrapper">
                {applications?.map((application, idx) => (
                  <tr
                    className="hover-effect"
                    key={application._id}
                    onClick={() =>
                      history.push(`userLeaveApplications/${application._id}`)
                    }>
                    <td>{idx + 1}</td>
                    <td>{application.type}</td>
                    <td>{application.title}</td>
                    <td>
                      {new Date(application?.appliedDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                    <td
                      className={`${
                        isLeader
                          ? !application.adminResponse ||
                            application.adminResponse?.toLowerCase() === "pending"
                            ? "text-warning"
                            : application.adminResponse?.toLowerCase() ===
                              "rejected"
                            ? "text-danger"
                            : "text-success"
                          : !application.adminResponse ||
                            !application.leaderResponse ||
                            application.adminResponse?.toLowerCase() === "pending" ||
                            application.leaderResponse?.toLowerCase() === "pending"
                          ? "text-warning"
                          : application.adminResponse?.toLowerCase() ===
                              "rejected" ||
                            application.leaderResponse?.toLowerCase() ===
                              "rejected"
                          ? "text-danger"
                          : "text-success"
                      }`}>
                      {isLeader
                        ? !application.adminResponse ||
                          application.adminResponse?.toLowerCase() === "pending"
                          ? "Pending"
                          : application.adminResponse?.toLowerCase() ===
                            "rejected"
                          ? "Rejected"
                          : "Approved"
                        : !application.adminResponse ||
                          !application.leaderResponse ||
                          application.adminResponse?.toLowerCase() === "pending" ||
                          application.leaderResponse?.toLowerCase() === "pending"
                        ? "Pending"
                        : application.adminResponse?.toLowerCase() ===
                            "rejected" ||
                          application.leaderResponse?.toLowerCase() ===
                            "rejected"
                        ? "Rejected"
                        : "Approved"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Team Members Leave Section - Only visible for leaders */}
          {isLeader && (
            <div className="mt-5">
              <section className="section">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <h4>Team Members' Leave Applications</h4>
                  </div>
                </div>
                {teamLeavesLoading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive mt-3">
                    <table className="table table-striped table-md center-text">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Employee Name</th>
                          <th>Type</th>
                          <th>Title</th>
                          <th>Applied Date</th>
                          <th>Admin Response</th>
                          <th>Leader Response</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="sidebar-wrapper">
                        {teamLeaves && teamLeaves.length > 0 ? (
                          teamLeaves.map((leave, idx) => (
                            <tr className="hover-effect" key={leave._id}>
                              <td>{idx + 1}</td>
                              <td>
                                {users.find(
                                  (user) => user.id === leave.applicantID
                                )?.name || ""}
                              </td>
                              <td>{leave.type}</td>
                              <td>{leave.title}</td>
                              <td>
                                {new Date(leave?.appliedDate)
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}
                              </td>
                              <td
                                className={`${
                                  leave.adminResponse?.toLowerCase() ===
                                  "rejected"
                                    ? "text-danger"
                                    : leave.adminResponse?.toLowerCase() ===
                                      "pending"
                                    ? "text-warning"
                                    : "text-success"
                                }`}>
                                {leave.adminResponse
                                  ? leave.adminResponse
                                      .charAt(0)
                                      .toUpperCase() +
                                    leave.adminResponse.slice(1).toLowerCase()
                                  : ""}
                              </td>
                              <td
                                className={`${
                                  leave.leaderResponse?.toLowerCase() ===
                                  "rejected"
                                    ? "text-danger"
                                    : leave.leaderResponse?.toLowerCase() ===
                                      "pending"
                                    ? "text-warning"
                                    : "text-success"
                                }`}>
                                {leave.leaderResponse
                                  ? leave.leaderResponse
                                      .charAt(0)
                                      .toUpperCase() +
                                    leave.leaderResponse.slice(1).toLowerCase()
                                  : ""}
                              </td>
                              <td>
                                <div className="d-flex justify-content-center">
                                  <button
                                    className="btn btn-sm btn-info mx-1"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleViewLeaveDetails(leave._id);
                                    }}>
                                    <i className="fas fa-eye"></i> Review
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No team leave applications found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </section>
            </div>
          )}
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default LeaveApplications;
